module.exports = __webpack_public_path__ + "static/img/btn_fold@3x.21a58c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/btn_fold@3x.png
// module id = +KgP
// module chunks = 10